import { Injectable } from "@angular/core";
import { BcpPublicKey } from "@cix-software-labs/ng-networking";
import { environment } from '@environments/environment';

@Injectable()
export class ConfigHttpService implements BcpPublicKey {

  async getPublicKey(): Promise<string> {
    return environment.TRANSIT_ENCRYPTION_PUBLIC_KEY;
  }
}